import type { Project } from '../../types'

export type ProjectDropPosition = 'before' | 'after'

export function isSameProjectOrder(left: Project[], right: Project[]) {
    return left.length === right.length
        && left.every((project, index) => project.id === right[index]?.id)
}

export function reorderProjects(
    projects: Project[],
    draggedProjectId: number,
    targetProjectId: number,
    position: ProjectDropPosition,
) {
    if (draggedProjectId === targetProjectId) return projects

    const draggedProject = projects.find((project) => project.id === draggedProjectId)
    if (!draggedProject) return projects

    const projectsWithoutDragged = projects.filter((project) => project.id !== draggedProjectId)
    const targetIndex = projectsWithoutDragged.findIndex((project) => project.id === targetProjectId)
    if (targetIndex === -1) return projects

    const nextProjects = [...projectsWithoutDragged]
    nextProjects.splice(targetIndex + (position === 'after' ? 1 : 0), 0, draggedProject)

    return isSameProjectOrder(projects, nextProjects) ? projects : nextProjects
}

export function mergeProjectOrder(projects: Project[], orderedProjects: Project[]) {
    const orderedIds = new Set(orderedProjects.map((project) => project.id))
    const queue = [...orderedProjects]
    const nextProjects = projects.map((project) => (
        orderedIds.has(project.id) ? (queue.shift() || project) : project
    ))

    return isSameProjectOrder(projects, nextProjects) ? projects : nextProjects
}
